module.exports = __webpack_public_path__ + "img/document-like.93d13a1c.png";